import type { Size as IconSize } from 'palette/Icon';
import { TypographyProps } from 'palette/Typography';

export const THEMES = ['primary', 'secondary', 'positive', 'negative', 'dark', 'booztPay'] as const;
export type Theme = typeof THEMES[number];

export const SIZES = ['large', 'medium', 'small', 'x-small'] as const;
export type Size = typeof SIZES[number];

export const SHAPES = ['rectangle', 'round'] as const;
export type Shape = typeof SHAPES[number];

export const ICON_POSITIONS = ['left', 'right'] as const;
export type IconPosition = typeof ICON_POSITIONS[number];

export const ICON_SIZE_BY_BUTTON_SIZE: Record<Size, IconSize> = {
    large: 'medium',
    medium: 'small',
    small: 'x-small',
    'x-small': 'x-small',
};

export const TYPOGRAPHY_PROPS_BY_SIZE: Record<Size, TypographyProps> = {
    large: { type: 'body' },
    medium: { type: 'body' },
    small: { type: 'small' },
    'x-small': { type: 'small', level: '2' },
};
